import axios from 'axios'
import qs from 'qs'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 5000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    // "Cache-Control": "no-cache",
    // 'Access-Control-Allow-Headers':'Content-Type'
  },
})
// service.interceptors.request.use(
//   config => {
//     if (config.data) {
//       config.params.code = 'web'
//     } else {
//       config.params.code = 'web'
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(err);
//   }
// );
// request interceptor
service.interceptors.request.use(config => {
  if (config.method === "post") {
    // 序列化
    config.data = qs.stringify(config.data);
    // 温馨提示,若是贵公司的提交能直接接受json 格式,可以不用 qs 来序列化的
  }

  // Do something before request is sent
  //   if (store.getters.token) {
  //     config.headers['X-Token'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  //   }
  return config
}, error => {
  return Promise.reject(error);
});

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js